<div class="container-visualizacao-sc" *ngIf="!isFormOpen">
    <div class="row container-visualizacao-sc-options">
        <div class="col-12">
            <button type="button" class="btn btn-link" (click)="insert()"><i class="fas fa-plus" aria-hidden="true"></i> Nova Sub-região</button>                 
        </div>
    </div>
    <div class="row container-visualizacao-sc-table">
        <div class="col-12">
            <table class="table table-striped table-hover datatables" id="tableSubRegioes">
                <thead>
                    <tr>
                        <th class="col-options"></th>
                        <th class="col-nome">Nome</th>
                        <th class="col-classificacao text-center">Classificação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entity of entities; let i = index">
                        <td class="col-options">
                            <a (click)="edit(i)"><i class="fas fa-pencil-alt" aria-hidden="true"></i></a>
                            <a (click)="delete(i)"><i class="far fa-trash-alt" aria-hidden="true"></i></a>
                        </td>
                        <td class="col-nome">{{entity.nome}}</td>
                        <td class="col-classificacao text-center">
                            {{entity.classificacao | cidadeClassificacaoAbc}}
                        </td>
                    </tr>
                </tbody>
            </table>                     
        </div>
    </div>    
</div>

<sgt-cidade-sub-regiao-form
    [entities]="entities"
    [isOpen]="isFormOpen"
    (save)="onFormSave($event)"
    (cancel)="onFormCancel()"
    #form>
</sgt-cidade-sub-regiao-form>
    